import React from 'react';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';
import './Message.css';

export const Message = (props) => (
  <Toast className='toastTop' isOpen={props.msg.show}>
    <ToastHeader closebutton closelabel='X' toggle={props.clear}>
      {props.msg.data && props.msg.data.type}
    </ToastHeader>
    <ToastBody>{props.msg.data && props.msg.data.text}</ToastBody>
  </Toast>
);
